import axios from 'axios'
import { Message } from 'element-ui'

const api = axios.create({
  // baseURL: '/dizal',
  baseURL: 'https://www.dizalpharma.com/dizal',
  timeout: 1000 * 60,
  responseType: 'json',
  headers: {
    get: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    post: {
      'Content-Type': 'application/json;charset=utf-8'
    }
  }
})

api.interceptors.request.use(
  request => {
    return request
  },
  error => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    let message = error.message
    if (message === 'Network Error') {
      message = '后端网络故障'
    } else if (message.includes('timeout')) {
      message = '接口请求超时'
    } else if (message.includes('Request failed with status code')) {
      message = `接口${message.substr(message.length - 3)}异常`
    }
    Message({
      message,
      type: 'error'
    })
    return Promise.reject(error)
  }
)

// 封装post,get方法
const http = {
  get(url = '', params = {}, config = {}) {
    return new Promise((resolve, reject) => {
      api({ url, params, method: 'GET', ...config })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  delete(url = '', params = {}) {
    return new Promise((resolve, reject) => {
      api({ url, params, method: 'DELETE' })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  post(url = '', params = {}, config = {}) {
    return new Promise((resolve, reject) => {
      api({ url, data: params, method: 'POST', ...config })
        .then(res => {
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default http



// WEBPACK FOOTER //
// ./src/util/request.js